import { ApiStrategyTemplate } from 'api/rtk-api'

import { EditStrategiesActions } from '../../../../modules/strategy-admin/state/edit-strategy-slice'
import { Errors } from '../../../../modules/tradebuilder-v2/util'
import { Attribute, FormItem, Label, NumberInput, ValidationMessage } from '../..'

type LeverageParameterInputProps = {
  actions: EditStrategiesActions
  errors: Errors
  strat: ApiStrategyTemplate
}

export function LeverageParameterInput({ actions, errors, strat }: LeverageParameterInputProps) {
  return (
    <FormItem>
      <Label>Leverage ratio</Label>
      <Attribute nameComponent="Minimum">
        <NumberInput
          value={strat.minLeverageRatio === 0 ? '' : strat.minLeverageRatio}
          onChange={v => actions.setMinLeverageRatio(Number(v.target.value))}
        />
      </Attribute>
      <Attribute nameComponent="Default">
        <NumberInput
          value={strat.defaultLeverageRatio === 0 ? '' : strat.defaultLeverageRatio}
          onChange={v => actions.setDefaultLeverageRatio(Number(v.target.value))}
        />
      </Attribute>
      <Attribute nameComponent="Maximum">
        <NumberInput
          value={strat.maxLeverageRatio === 0 ? '' : strat.maxLeverageRatio}
          onChange={v => actions.setMaxLeverageRatio(Number(v.target.value))}
        />
      </Attribute>
      <ValidationMessage errors={errors} fieldName="leverage_ratios" />
      <ValidationMessage errors={errors} fieldName="min_lev_ratio" />
      <ValidationMessage errors={errors} fieldName="max_lev_ratio" />
    </FormItem>
  )
}
